import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useParams, useNavigate } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';
import './BookListPage.css';

const baseUrl = process.env.REACT_APP_BASE_URL;

function BookListPage() {
    const { language,mainCategory, category } = useParams();
    const navigate = useNavigate();

    const [selectedCategory, setSelectedCategory] = useState('');
    const [selectedMainCategory, setSelectedMainCategory] = useState('');
    const [selectedLanguage, setSelectedLanguage] = useState('Hindi');
    const [books, setBooks] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [showLoadMore, setShowLoadMore] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const booksPerPage = 10;

    const languageSpecificCat = ['News','Radio Udaan'];

    // Fetch books on component mount
    useEffect(() => {
        if (category) {
            setSelectedCategory(category);
        }
        if (language) {
            setSelectedLanguage(language);
        }
        if (mainCategory) {
            setSelectedMainCategory(mainCategory);
        }

        const fetchBooks = async () => {
            setCurrentPage(1);
            try {
                if (category) {
                    setLoading(true);
                    setError(null);
                    const encodedCategory = encodeURIComponent(category);
                    let response;
                    if(mainCategory === "books" || languageSpecificCat.includes(category)){
                        response = await axios.get(`${baseUrl}/ivr/booksByCategoryAndLang?category=${encodedCategory}&language=${language}&limit=${booksPerPage}`);
                    }else{
                        response = await axios.get(`${baseUrl}/ivr/booksByCategory?category=${encodedCategory}&limit=${booksPerPage}`);
                    }
                    const data = await response.data;
                    setBooks(data);
                    setShowLoadMore(true);
                } else {
                    setBooks(null); // Clear books if no category is selected
                    setShowLoadMore(false);
                }
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchBooks();
    }, []);

    const handleAudioBookClick = (audiobook) => {
        localStorage.setItem('currentAudiobook', JSON.stringify(audiobook));
    };

    const handleLoadMore = async () => {
        if (selectedCategory) {
            setLoading(true);
            setError(null);

            const currentPageCount = currentPage;
            try {
                const response = await axios.get(`${baseUrl}/ivr/booksByCategoryAndLang?category=${selectedCategory}&language=${selectedLanguage}&page=${currentPageCount + 1}&limit=${booksPerPage}`);
                const data = await response.data;
                setCurrentPage(currentPageCount + 1);
                if (data.length) {
                    setBooks([...books, ...data]);
                } else {
                    setShowLoadMore(false);
                }
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        } else {
            console.log('empty books')
            setBooks(null); // Clear books if no category is selected
            setShowLoadMore(false);
        }
    };


    return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
            <div className='container'>
                <section className="header-wrap d-flex justify-content-start align-items-center">
                    <button onClick={() => { navigate(-1); }} className="btn btn-secondary">
                        Go Back
                    </button>
                    <h1 className="logo my-auto ms-4">
                        <span className="assistive-text">Shravan Audiobooks Library</span>
                    </h1>
                </section>
                {
                    books != null && books.length > 0 ?
                        (
                            <section className="audiobooks-container mt-5">
                                <div className="audio-book-feed justify-content-start align-items-center" id="secondary-content">
                                    {
                                        selectedCategory && (
                                            <header>
                                                {
                                                    mainCategory === "books" || languageSpecificCat.includes(selectedCategory) ? 
                                                    (
                                                        <h3 className="title text-start">Audiobooks listed under {selectedCategory} in {selectedLanguage} language</h3>
                                                    ) :
                                                    (
                                                        <h3 className="title text-start">Audiobooks listed under {selectedCategory}</h3>
                                                    )
                                                }                                               
                                            </header>
                                        )
                                    }
                                    <ul className='list-group audiobooks-list mt-3'>
                                        {
                                            books.map((audiobook, index) => (
                                                <li key={audiobook._id} className='list-group-item audiobook-item'>
                                                    <Link
                                                        to={`/play/${selectedMainCategory}/${selectedCategory}/${audiobook.bookName}`}
                                                        onClick={() => handleAudioBookClick(audiobook)}
                                                        style={{ textDecoration: 'none', color: 'inherit' }}
                                                    >
                                                        <div className="result-data d-flex justify-content-start align-items-baseline">
                                                            <p className='mb-0'>{index + 1}. {audiobook.bookName}</p>
                                                            <span className="ms-3 book-author">Author: {audiobook.author}</span>
                                                        </div>
                                                    </Link>
                                                </li>
                                            ))
                                        }
                                    </ul>
                                    {
                                        showLoadMore && (
                                            <button className="load-more-button btn btn-primary" onClick={handleLoadMore}>
                                                Load More
                                            </button>
                                        )
                                    }

                                </div>
                            </section>
                        ) :
                        <div className="empty-container mt-5">
                            {
                                books && books.length == 0 ?
                                (
                                    <p className='d-flex text-left'>No books found</p>
                                )
                                : (
                                    <p></p>
                                )              
                            }
                           
                        </div>
                }

            </div>
        </div>
    );
}

export default BookListPage;
